import PropTypes from 'prop-types';
import { memo } from 'react';

import Breadcrumb from 'shopper/components/Breadcrumb/V2';
import Icon from 'shopper/components/Icon';

import { toCategoryLink, toSubcategoryLink } from 'lib/links';
import { sliceWithEllipsis } from 'lib/string';

import LINKS from 'constants/links';

const OFFER_TITLE_CHAR_LIMIT = 48;

const OfferBreadcrumb = ({
  categoryName,
  categorySlug,
  offerTitle = null,
  subcategoryName = null,
  subcategorySlug,
}) => (
  <Breadcrumb.Root>
    <Breadcrumb.Item
      aria-label="Ir para página inicial"
      icon={<Icon name="home" />}
      link={LINKS.HOME}
    />
    <Breadcrumb.Item link={toCategoryLink(categorySlug)}>
      {categoryName}
    </Breadcrumb.Item>
    {subcategoryName && (
      <Breadcrumb.Item link={toSubcategoryLink(subcategorySlug)}>
        {subcategoryName}
      </Breadcrumb.Item>
    )}
    <Breadcrumb.Item>
      {sliceWithEllipsis(offerTitle, OFFER_TITLE_CHAR_LIMIT)}
    </Breadcrumb.Item>
  </Breadcrumb.Root>
);

OfferBreadcrumb.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  offerTitle: PropTypes.string,
  subcategoryName: PropTypes.string,
  subcategorySlug: PropTypes.string,
};

export default memo(OfferBreadcrumb);
